import { useQuery } from "@tanstack/react-query";
import { fetchDonorOverview, fetchAgreementCharges } from "@/lib/donors";

export function useDonorOverview() {
  return useQuery({
    queryKey: ["donors", "overview"],
    queryFn: fetchDonorOverview,
    staleTime: 30_000,
  });
}

export function useAgreementCharges(agreementId: string | undefined) {
  return useQuery({
    queryKey: ["donors", "charges", agreementId],
    queryFn: () => fetchAgreementCharges(agreementId!),
    enabled: Boolean(agreementId),
    staleTime: 30_000,
  });
}
